import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  problemDetails: {},
  userName: null,
}

const userProblemDetailsStore = createSlice({
  name: "swayamUserProblemDetails",
  initialState: initialState,
  reducers: {
    setProblemDetails: (state, action) => ({
      ...state,
      problemDetails: {
        ...action.payload,
      },
    }),
    setUserName: (state, action) => ({
      ...state,
      userName: action.payload,
    }),
    resetUserProblemDetails: () => initialState,
  },
})

export const { setProblemDetails, setUserName, resetUserProblemDetails } = userProblemDetailsStore.actions

export default userProblemDetailsStore.reducer
